



























































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import OrderSummary from "@/components/checkout/OrderSummary.vue";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderActions, OrderGetters } from "@/store/modules/order/types";
import {
  LineItem,
  LineItemRecord,
  Note,
  Order,
  OrderRecord
} from "@/models/order/order";
import QtyPicker from "@/components/elements/utility/QtyPicker.vue";
import ConfirmDelete from "@/components/elements/modal/ConfirmDelete.vue";
import ShowAllNotesModal from "@/components/elements/modal/ShowAllNotesModal.vue";
import OrderService from "@/services/order_service";
import { GenericError } from "@/services/error_service";
import { ProductType } from "@/models/products/product";
import CartFooter from "@/components/footer/CartFooter.vue";
import { Mobile } from "@/mixins/mobile";
import { CreatedType, NoteFields, OrderStatus } from "@/models/order/helpers";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import { PriceLevel } from "@/models/netsuite/netsuite";
import { FinishDisplayName, FinishHandle } from "@/models/products/finish";
import {
  getFinishName,
  getFinialFinishDisplayName,
  priceLevelMultiplier
} from "@/utility/helpers";
import FabricService from "@/services/fabric_service";
import * as option from "../../models/configurator/configurator_options";
import * as canopyDisplay from "@/models/configurator/canopy_display";
import { UmbrellaType } from "@/models/products/umbrella";
import { Collection, ProductLineName } from "@/models/products/collection";
import { hasFinial } from "@/mixins/business_logic/finial_rules";
import { grommetOnlyModels } from "@/mixins/business_logic/rib_rules";
import { OrderMixin } from "@/mixins/orders/mixin";
import DriftResolver from "@/components/checkout/DriftResolver.vue";
import AccuracyWarningIcon from "@/components/cart/AccuracyWarningIcon.vue";
import { DriftReport } from "@/models/quote_draft/quote_draft";

/** Breathing room kept between a Details tooltip and the viewport edge, px. */
const TOOLTIP_GAP = 12;

/**
 * Gap left between a flipped tooltip and the top of the line name it opens
 * above, px. Deliberately tiny: the name's own line-height already leaves
 * several pixels of visual air below this box edge, so anything larger reads as
 * a gap floating over the line above rather than as a panel on this line.
 */
const TOOLTIP_NAME_GAP = 2;

@Component({
  components: {
    OrderSummary,
    QtyPicker,
    ConfirmDelete,
    ShowAllNotesModal,
    CartFooter,
    DriftResolver,
    AccuracyWarningIcon
  }
})
export default class Cart extends Mixins(Mobile, OrderMixin) {
  @(namespace(StoreModule.Order).Action(OrderActions.AddLineItem))
  addItem!: (value: LineItem) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.ReplaceLineItems))
  replaceLineItems!: (value: LineItem[] | LineItemRecord[]) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AddOrder))
  addOrder!: (value: Order) => Promise<void>;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: PriceLevel | null) => Promise<void>;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetMultiplier))
  multiplier!: PriceLevel | null;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetPriceLevels))
  storePriceLevels!: PriceLevel[];
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrder))
  storeOrder!: Order;
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetDriftReport))
  driftReport!: DriftReport | null;
  @(namespace(StoreModule.Order).Action(OrderActions.ClearOrder))
  resetOrder!: () => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AssignCustomer))
  assignCustomer!: (value: {
    customer_id: string;
    customer_name: string;
    customer_netsuite_id: number | undefined;
    customer_netsuite_price_level_id: number | undefined;
    order_id: string | null;
  }) => Promise<void>;
  protected showModal = false;
  protected orderService = new OrderService();
  protected fabricService = new FabricService();
  protected upForDelete: number | null = null;
  protected loader: any = null;
  protected id = "";
  protected productType = ProductType;
  protected option = option;
  protected finishName: FinishHandle | null = null;
  protected showSummary = false;
  protected showNotesModal = false;
  protected activeNoteObj: Record<string, string> | null = null;
  protected activeNoteIndex: number | null = null;
  protected spigotNote = "Intended for Spigot use - No stem requested.";
  protected beautyPlateNote = "Beauty plate included.";
  protected qtyWarnings: Record<number, boolean> = {};
  /** Per-line-index: does that line's Details tooltip open upward? */
  protected tooltipAbove: Record<number, boolean> = {};
  /** Per-line-index: px a flipped tooltip is lifted to clear the line's name. */
  protected tooltipShift: Record<number, number> = {};

  /**
   * A drift report is only stored when there is line drift to resolve, and it
   * is cleared once the DriftResolver saves. While it exists the rest of the
   * cart is locked so the user can't edit or check out a stale quote.
   */
  get hasUnresolvedDrift(): boolean {
    return !!this.driftReport;
  }

  get activeItemIsSpigot(): boolean {
    if (this.activeNoteIndex == null) return false;
    const item = this.items[this.activeNoteIndex];
    if (item?.product_type !== ProductType.Base) return false;
    const details = item.item_details as any;
    return details?.base?.baseStem === "Spigot";
  }

  get activeItemHasBeautyPlate(): boolean {
    if (this.activeNoteIndex == null) return false;
    const item = this.items[this.activeNoteIndex];
    if (item?.product_type !== ProductType.Base) return false;
    const details = item.item_details as any;
    if (!details?.base?.baseStem || details.base.baseStem === "Spigot")
      return false;
    const productLines = details?.base?.base?.product_lines;
    if (!productLines) return false;
    return productLines.some(
      (pl: Collection) =>
        pl.umbrella_type === UmbrellaType.Cantilever ||
        pl.display_name === "Nova"
    );
  }

  get activeItemHasUmbrellaSpigot(): boolean {
    if (this.activeNoteIndex == null) return false;
    const item = this.items[this.activeNoteIndex];
    if (item?.product_type !== ProductType.Umbrella) return false;
    const details = item.item_details as any;
    return details?.frame?.spigot === option.Spigot.StainlessSteel;
  }

  get activeUmbrellaSpigotNote(): string {
    if (!this.activeItemHasUmbrellaSpigot) return "";
    return "Stainless Steel";
  }

  get activeItemHasFinialFinishNote(): boolean {
    if (this.activeNoteIndex == null) return false;
    const item = this.items[this.activeNoteIndex];
    if (item?.product_type !== ProductType.Umbrella) return false;
    if (item.product_line === ProductLineName.Eclipse) return false;
    const details = item.item_details as any;
    const finish = details?.frame?.finialFinish;
    if (finish === option.FinialFinishType.SS) return true;
    const montereyMarket: string[] = [
      ProductLineName.MontereyPulleyLift,
      ProductLineName.MontereyAutoTilt,
      ProductLineName.MontereyCrank
    ];
    if (montereyMarket.includes(item.product_line)) {
      return finish === option.FinialFinishType.CH;
    }
    return false;
  }

  get activeFinialFinishNote(): string {
    if (!this.activeItemHasFinialFinishNote) return "";
    const item = this.items[this.activeNoteIndex!];
    const details = item.item_details as any;
    if (details?.frame?.finialFinish === option.FinialFinishType.CH) {
      return "Chrome";
    }
    return "Stainless Steel Upgrade";
  }

  get activeItemHasNonStandardRib(): boolean {
    if (this.activeNoteIndex == null) return false;
    const item = this.items[this.activeNoteIndex];
    if (item?.product_type !== ProductType.Umbrella) return false;
    const details = item.item_details as any;
    const rib = details?.canopy?.rib;
    if (!rib) return false;
    // Grommet-only models: grommets is always standard
    if (grommetOnlyModels.includes(item.model)) {
      return rib !== option.Rib.Grommets;
    }
    const grommetsStandard: string[] = [
      ProductLineName.Greenwich,
      ProductLineName.GreenwichGSeries,
      ProductLineName.MontereyGSeries,
      ProductLineName.Eclipse,
      ProductLineName.Aurora
    ];
    if (grommetsStandard.includes(item.product_line)) {
      return rib !== option.Rib.Grommets;
    }
    return rib !== option.Rib.Pockets;
  }

  get activeNonStandardRibNote(): string {
    if (!this.activeItemHasNonStandardRib) return "";
    const item = this.items[this.activeNoteIndex!];
    const details = item.item_details as any;
    return details?.canopy?.rib === option.Rib.Grommets
      ? "Grommets"
      : "Pockets";
  }

  get activeItemHasNonStandardBottomPole(): boolean {
    if (this.activeNoteIndex == null) return false;
    const item = this.items[this.activeNoteIndex];
    if (item?.product_type !== ProductType.Umbrella) return false;
    const details = item.item_details as any;
    return details?.frame?.bottomPole === option.BottomPole.Bar;
  }

  get activeNonStandardBottomPoleNote(): string {
    if (!this.activeItemHasNonStandardBottomPole) return "";
    return "Bar Height Bottom Pole upgrade.";
  }

  get activeItemHasNonStandardFinial(): boolean {
    if (this.activeNoteIndex == null) return false;
    const item = this.items[this.activeNoteIndex];
    if (item?.product_type !== ProductType.Umbrella) return false;
    if (!hasFinial.includes(item.product_line as ProductLineName)) return false;
    const details = item.item_details as any;
    const finial = details?.frame?.finial;
    if (!finial) return false;
    const isGreenwich =
      item.product_line === ProductLineName.Greenwich ||
      item.product_line === ProductLineName.GreenwichGSeries;
    const defaultFinial = isGreenwich
      ? option.Finial.Vertex
      : option.Finial.Ball;
    return finial !== defaultFinial;
  }

  get activeNonStandardFinialNote(): string {
    if (!this.activeItemHasNonStandardFinial) return "";
    const item = this.items[this.activeNoteIndex!];
    const isGreenwich =
      item.product_line === ProductLineName.Greenwich ||
      item.product_line === ProductLineName.GreenwichGSeries;
    return isGreenwich ? "Classic Ball" : "Vertex";
  }

  @Watch("finishName")
  private getFinishName(stringHandle: FinishHandle): FinishDisplayName {
    return getFinishName(stringHandle);
  }

  private getFinialFinishDisplayName(
    finishType: option.FinialFinishType | null
  ): string {
    return getFinialFinishDisplayName(finishType);
  }

  @Watch("multiplier")
  onMultiplierChanged(): void {
    this.loadCartPriceLevels();
  }

  async created(): Promise<void> {
    if (this.$route.params.id) {
      this.showLoader();
      const editExisting = this.$route.query.edit as string;
      const id = this.$route.params.id;
      const status = this.$route.query.status;
      if (editExisting || status === OrderStatus.Open) {
        await this.getQuote(id as string, editExisting);
      } else {
        await this.getOrder(id as string, editExisting);
      }
    } else {
      this.showSummary = true;
    }
    this.loadCartPriceLevels();
  }

  /**
   * FUPOF-191: canopy-display helpers live in @/models/configurator/canopy_display
   * so the Details tooltip and buildLineDescription (NetSuite Production Notes)
   * share one source of truth. These thin wrappers keep them callable from the
   * template.
   */
  protected hasStructuredCanopy(item: LineItem): boolean {
    return canopyDisplay.hasStructuredCanopy(item);
  }

  protected hasStructuredBase(item: LineItem): boolean {
    return canopyDisplay.hasStructuredBase(item);
  }

  protected hasStructuredChair(item: LineItem): boolean {
    return canopyDisplay.hasStructuredChair(item);
  }

  /**
   * A NetSuite-added line whose configuration the SKU parser rebuilt into a
   * shape the Details tooltip cannot render. It is still editable — that it
   * parsed at all is what unlocked it — and editing rehydrates the config, so
   * this state is temporary and worth explaining rather than leaving blank.
   * ns_locked lines are excluded: they failed to parse and are not editable, so
   * there is nothing for the user to review.
   */
  protected isReconstructedFromSku(item: LineItem): boolean {
    // A locked line never parsed, so there is nothing to review.
    if (item.ns_locked) return false;
    const configurable: string[] = [
      this.productType.Umbrella,
      this.productType.Base,
      this.productType.Chair
    ];
    if (!configurable.includes(item.product_type)) return false;
    // No configuration at all is a different state (and a different pill) —
    // this one is specifically "there IS a configuration, but a rebuilt one".
    if (!item.item_details) return false;
    // The API says so outright when it tells us (drift-report orphans carry
    // `parsed`); otherwise fall back to the structural check, which is what
    // separates a rebuilt configuration (bare mfr-code strings and flat
    // handles) from one this app authored (swatch and finish objects).
    return !!item.ns_parsed || !canopyDisplay.hasStructuredConfig(item);
  }

  /**
   * Any line NetSuite is the source of — whether it parsed into an editable
   * configuration or stayed locked. Both carry the "Added in NetSuite" pill;
   * only the parsed ones also get the accuracy warning below.
   */
  protected isNsOriginLine(item: LineItem): boolean {
    return !!item.ns_locked || this.isReconstructedFromSku(item);
  }

  /**
   * The line's configuration was reconstructed rather than authored here, so it
   * is worth a look before the quote goes out. Drives both the warning glyph
   * beside the title and the "Review for accuracy" link under the SKU.
   */
  protected needsAccuracyReview(item: LineItem): boolean {
    return this.isReconstructedFromSku(item);
  }

  /**
   * Flip the Details tooltip above its trigger when there isn't room below it —
   * the last line in the cart otherwise renders its tooltip off the bottom of
   * the page with nothing to scroll to.
   *
   * A flipped tooltip is also lifted clear of its own line's name/model/SKU.
   * Anchored straight to the trigger it would cover them, leaving no way to
   * tell which line the open panel belongs to — the one thing the downward
   * placement never loses.
   */
  protected positionTooltip(index: number, event: MouseEvent): void {
    const wrap = event.currentTarget as HTMLElement;
    const measure = (): void => {
      const tip = wrap.querySelector(".detail-tooltip") as HTMLElement | null;
      if (!tip || !tip.offsetHeight) return;
      const rect = wrap.getBoundingClientRect();
      // The trigger's parent is the line's identity block, so its top is the
      // top of the name; clear that plus a gap when opening upward.
      const identityTop =
        wrap.parentElement?.getBoundingClientRect().top ?? rect.top;
      const shift = Math.max(0, rect.top - identityTop) + TOOLTIP_NAME_GAP;
      const spaceBelow = window.innerHeight - rect.bottom;
      // Only flip when it genuinely fits better above — counting the lift, so a
      // tooltip that would then run off the top stays put rather than trading
      // one overflow for another.
      const needed = tip.offsetHeight + TOOLTIP_GAP;
      const above = needed > spaceBelow && rect.top - shift > spaceBelow;
      this.$set(this.tooltipShift, index, shift);
      this.$set(this.tooltipAbove, index, above);
    };
    // :hover has normally already displayed the tooltip by the time this fires,
    // so measure inline to avoid a visible drop-then-flip. The frame callback
    // is the fallback for when it hasn't.
    measure();
    if (this.tooltipAbove[index] === undefined) {
      window.requestAnimationFrame(measure);
    }
  }

  /** Extra lift applied to a flipped tooltip; see positionTooltip(). */
  protected tooltipStyle(index: number): Record<string, string> {
    const shift = this.tooltipShift[index];
    if (!this.tooltipAbove[index] || !shift) return {};
    return { bottom: `calc(100% + ${shift}px)` };
  }

  /**
   * FUPOF-191: a line whose CONTENT came from NetSuite rather than from this
   * app — adopted/locked, or reconstructed by the SKU parser.
   *
   * `ns_line_id` used to be part of this test, on the reading that only a
   * NetSuite-generated line would carry one. It isn't: `applySubmittedDraft`
   * stamps an `ns_line_id` onto EVERY line of a quote the moment it is
   * submitted, so after one submit every line the rep built here answered yes —
   * and any of them whose configuration `hasStructuredConfig` doesn't recognise
   * (see `isReconstructedFromSku`) then wore an "Added in NetSuite" pill and a
   * "Review for accuracy" link on a line that had never been near NetSuite.
   *
   * `ns_locked` is the flag that actually means "NetSuite owns this line's
   * content": the API sets it on adopt for any line the parser couldn't
   * reconstruct (every TEMP-CUST-ITEM custom line included), and the
   * DriftResolver sets it when the rep accepts NetSuite's SKU. A line that
   * parsed cleanly on adopt comes back unlocked but with a flat, SKU-derived
   * configuration, which is what the structural check below is for.
   */
  protected isNetSuiteLine(item: LineItem): boolean {
    return !!item.ns_locked || !!item.ns_parsed;
  }

  // Main = Top
  protected hasEqualMainTopFabrics(canopy: any): boolean {
    return canopyDisplay.hasEqualMainTopFabrics(canopy);
  }

  // Main = Middle
  protected hasEqualMainMiddleFabrics(canopy: any): boolean {
    return canopyDisplay.hasEqualMainMiddleFabrics(canopy);
  }

  // Top = Middle
  protected hasEqualTopMiddleFabrics(canopy: any): boolean {
    return canopyDisplay.hasEqualTopMiddleFabrics(canopy);
  }

  protected editCartItem(index: number): void {
    this.editItem(index);
  }

  protected hasDesignerLayout(preset: option.Preset | null): boolean {
    return canopyDisplay.hasDesignerLayout(preset);
  }

  protected getDesignerLayoutName(preset: option.Preset): string {
    return canopyDisplay.getDesignerLayoutName(preset);
  }

  /**
   * editExisting === true -> edit
   * editExisting === false -> duplicate
   *
   */
  protected async getQuote(id: string, editExisting = ""): Promise<void> {
    this.id = id;
    let isEdit = false;
    if (editExisting && editExisting === "true") {
      isEdit = true;
    }
    try {
      const res: OrderRecord = await this.orderService.getSingleQuote(
        id,
        !editExisting ? true : false
      );
      res.created_type = !editExisting ? CreatedType.Duplicated : undefined;
      await this.resetOrder();
      await this.addOrder(res as any);
      if (res.customer_id && (res.customer_id as any)._id) {
        // const customer = await this.customerService.getSingleCustomer(
        //   res.customer_id._id
        // );
        await this.assignCustomer({
          customer_id: (res.customer_id as any)._id,
          customer_name: (res.customer_id as any).customer_name,
          customer_netsuite_id: (res.customer_id as any).netsuite_id,
          customer_netsuite_price_level_id: (res.customer_id as any)
            .netsuite_price_level_id,
          order_id: isEdit ? id : null // will create a new order when saving if there is no id in the store. if isEdit is true, we are editing quote (vs duplicating)
        });
      } else {
        await this.assignCustomer({
          customer_id: "",
          customer_name: "",
          customer_netsuite_id: undefined,
          customer_netsuite_price_level_id: undefined,
          order_id: isEdit ? id : null // will create a new order when saving if there is no id in the store. if isEdit is true, we are editing quote (vs duplicating)
        });
      }
      await this.replaceLineItems(res.items as LineItem[]);
      this.$nextTick(() => {
        this.closeLoader();
        this.showSummary = true;
      });
    } catch (err) {
      //this.$router.push("/not-found?error=order");
      this.$nextTick(() => this.closeLoader());
      GenericError.popup(err.message);
    }
  }

  protected async getOrder(id: string, editExisting = ""): Promise<void> {
    try {
      const res: OrderRecord = await this.orderService.getSingleOrder(
        id,
        !editExisting ? true : false
      );
      res.created_type = !editExisting ? CreatedType.Duplicated : undefined;
      await this.resetOrder();
      await this.addOrder(res as any);
      if (res.customer_id && (res.customer_id as any)._id) {
        // const customer = await this.customerService.getSingleCustomer(
        //   res.customer_id._id
        // );
        await this.assignCustomer({
          customer_id: (res.customer_id as any)._id,
          customer_name: (res.customer_id as any).customer_name,
          customer_netsuite_id: (res.customer_id as any).netsuite_id,
          customer_netsuite_price_level_id: (res.customer_id as any)
            .netsuite_price_level_id,
          order_id: null // will create a new order when saving if there is no id in the store
        });
      } else {
        await this.assignCustomer({
          customer_id: "",
          customer_name: "",
          customer_netsuite_id: undefined,
          customer_netsuite_price_level_id: undefined,
          order_id: null // will create a new order when saving if there is no id in the store
        });
      }
      await this.replaceLineItems(res.items as LineItem[]);
      this.$nextTick(() => {
        this.closeLoader();
        this.showSummary = true;
      });
    } catch (err) {
      //this.$router.push("/not-found?error=order");
      this.$nextTick(() => this.closeLoader());
      GenericError.popup(err.message);
    }
  }

  protected showLoader(): void {
    this.loader = this.$loading.show(
      {
        opacity: 1
      },
      {
        before: this.$createElement("h1", {
          domProps: { innerHTML: "Loading quote..." }
        })
      }
    );
  }

  protected closeLoader(): void {
    setTimeout(() => {
      this.loader.hide();
    }, 300);
  }

  protected deleteItem(): void {
    const itemsCopy = JSON.parse(JSON.stringify(this.items));
    itemsCopy.splice(this.upForDelete, 1);
    this.replaceLineItems(itemsCopy);
    this.close();
  }

  protected toggleModal(index: number) {
    this.showModal = true;
    this.upForDelete = index;
  }

  protected close(): void {
    this.upForDelete = null;
    this.showModal = false;
  }

  protected setQty(qty: number, index: number): void {
    this.triggerUpdate(index, { qty });
  }

  protected toggleCartQtyWarning(index: number, hasWarning: boolean): void {
    this.$set(this.qtyWarnings, index, hasWarning);
  }

  get hasAnyQtyWarning(): boolean {
    // Only current line indices count. A drift resolution can shorten the
    // cart (removed lines) or reorder it, but QtyPicker flags are keyed by
    // index and the unmounted pickers never emit a clearing `false` — so a
    // stale high-index flag would otherwise keep checkout disabled for good.
    return this.items.some((_, index) => !!this.qtyWarnings[index]);
  }

  protected triggerUpdate(index: number, options: { qty?: number }): void {
    const itemsCopy: LineItem[] = JSON.parse(JSON.stringify(this.items));
    const newItem = Object.assign({}, { ...this.items[index] }, options);
    itemsCopy.splice(index, 1, newItem);
    this.replaceLineItems(itemsCopy);
  }

  /**
   * Whether the cart's lines carry more than one multiplier. Rounded before
   * comparing: these are floats, and 1 + -0.63 is not exactly 0.37.
   */
  protected get hasMixedMultipliers(): boolean {
    const values = new Set(
      (this.items ?? []).map(item => (item.multiplier ?? 1).toFixed(4))
    );
    return values.size > 1;
  }

  protected loadCartPriceLevels(): void {
    let activeLevel:
      | import("@/models/netsuite/netsuite").PriceLevel
      | null = null;
    const isValidPriceLevel =
      this.multiplier !== null &&
      typeof this.multiplier === "object" &&
      "id" in (this.multiplier as any) &&
      typeof (this.multiplier as any).id === "number";
    if (!isValidPriceLevel && this.multiplier !== null) {
      // Stale non-object value in store (e.g. from old localStorage) — reset it
      this.addMultiplier(null);
    }
    if (isValidPriceLevel) {
      activeLevel = this.multiplier as PriceLevel;
    } else if (this.storeOrder?.customer_netsuite_price_level_id) {
      const match =
        this.storePriceLevels.find(
          l => l.id === this.storeOrder.customer_netsuite_price_level_id
        ) ?? null;
      if (match) {
        this.addMultiplier(match);
        activeLevel = match;
      }
    }
    if (activeLevel && this.items?.length) {
      // A cart that already holds more than one multiplier is deliberately
      // mixed — the rep accepted a NetSuite multiplier on a line, adopted an
      // NS-created line, or reopened a quote saved that way. Re-asserting the
      // quote-wide level over it here is exactly what the "Edit multipliers"
      // link did on the way back from checkout: the mix the warning is about
      // was erased by the act of following the warning. The mix is only ever
      // resolved deliberately — `EditMultiplier` (rep picks a level) or a
      // customer change (both go through `applyQuoteMultiplier`, which stamps
      // every line and releases the pins) — so leave it alone here.
      if (this.hasMixedMultipliers) return;
      const multiplierValue = priceLevelMultiplier(activeLevel.discountpct);
      const itemsCopy: LineItem[] = JSON.parse(JSON.stringify(this.items));
      itemsCopy.forEach((item, idx) => {
        // A pinned line keeps its own multiplier: the quote-wide level is the
        // default for the cart, not an authority that overrides a value the
        // line already carries. Re-stamping it here reverted a multiplier
        // accepted from NetSuite — silently, since totals just recalculated —
        // on any return trip to the cart, and did the same to a reopened quote
        // whose lines sit off the customer's default level (those are pinned by
        // OrderMixin.syncQuoteMultiplierFromLines, which also restores the
        // quote-wide level so this stamp is a no-op in the common case).
        // `EditMultiplier` clears the pins when the rep picks a level outright.
        if (item.ns_multiplier) return;
        itemsCopy[idx] = Object.assign({}, item, {
          multiplier: multiplierValue
        });
      });
      this.replaceLineItems(itemsCopy);
    }
  }

  protected async updateNotes(itemNotes: Note[], index: number) {
    const newDetails = Object.assign(
      {},
      { ...this.items[index].item_details! },
      { notes: itemNotes }
    );
    const newItem = JSON.parse(JSON.stringify(this.items[index]));
    newItem.item_details = newDetails;
    const itemsCopy = JSON.parse(JSON.stringify(this.items));
    itemsCopy.splice(index, 1, newItem);
    await this.replaceLineItems(itemsCopy);
  }

  protected openNotes(index: number): void {
    this.activeNoteIndex = index;
    const item = this.items[index];
    const itemNotes: Note[] = item.item_details?.notes || [];
    this.activeNoteObj = {} as any;

    let fields: string[] = [];
    switch (item.product_type) {
      case ProductType.Umbrella:
        fields = [
          "model",
          "canopy",
          "frame",
          "valance",
          "bottomPole",
          "finial",
          "rib",
          "spigot"
        ];
        break;
      case ProductType.Base:
        fields = ["finish", "stem", "model", "options"];
        break;
      case ProductType.Chair:
        fields = ["model", "fabric"];
        break;
      case ProductType.Accessory:
        fields = ["model"];
        break;
      default:
        // NetSuite lines that don't map to a known product_type still need a
        // place for notes — offer a single "General Item" block.
        fields = ["general"];
        break;
    }
    // An ns_locked line whose configuration couldn't be parsed keeps its
    // recovered NetSuite notes in the General block (see recoverLockedLineNotes).
    // Product types that carry their own field list omit "general", so surface
    // it whenever it holds content — no other boxes are added.
    const hasGeneralNote = itemNotes.some(
      n => n.field === NoteFields.General && n.content
    );
    if (hasGeneralNote && !fields.includes(NoteFields.General)) {
      fields.push(NoteFields.General);
    }
    fields.forEach(field => {
      const obj = itemNotes.find(e => e.field === field);
      // A note record can exist for a field with a null/undefined content
      // (NetSuite-added and drift-merged lines come back this way). Coerce to
      // a string so the .replace() calls below don't throw on null.
      let content = obj && obj.content ? obj.content : "";
      if (field === "stem") {
        content = content.replace(this.spigotNote, "").trim();
        content = content.replace(this.beautyPlateNote, "").trim();
      }
      if (field === "spigot") {
        content = content.replace(/^Stainless Steel\.?\s*/i, "").trim();
      }
      if (field === "rib") {
        content = content.replace(/^Grommets\.?\s*/i, "").trim();
        content = content.replace(/^Pockets\.?\s*/i, "").trim();
      }
      if (field === "bottomPole") {
        content = content
          .replace(/^Bar Height Bottom Pole upgrade\.?\s*/i, "")
          .trim();
      }
      if (field === "finial") {
        content = content.replace(/^Stainless Steel Upgrade\.?\s*/i, "").trim();
        content = content.replace(/^Chrome\.?\s*/i, "").trim();
        content = content.replace(/^Vertex\.?\s*/i, "").trim();
        content = content.replace(/^Classic Ball\.?\s*/i, "").trim();
      }
      this.activeNoteObj![field] = content;
    });

    this.showNotesModal = true;
  }

  protected closeNotes(): void {
    this.showNotesModal = false;
    if (this.activeNoteObj != null && this.activeNoteIndex != null) {
      const newItemNotes: Note[] = [];
      for (const [key, value] of Object.entries(this.activeNoteObj)) {
        let content = value as string;
        if (key === "stem" && this.activeItemIsSpigot) {
          content = content
            ? `${this.spigotNote} ${content}`
            : this.spigotNote;
        }
        if (key === "stem" && this.activeItemHasBeautyPlate) {
          content = content
            ? `${this.beautyPlateNote} ${content}`
            : this.beautyPlateNote;
        }
        if (key === "spigot" && this.activeItemHasUmbrellaSpigot) {
          const spigotLabel = this.activeUmbrellaSpigotNote;
          content = content
            ? `${spigotLabel}. ${content}`
            : spigotLabel;
        }
        if (key === "rib" && this.activeItemHasNonStandardRib) {
          const ribLabel = this.activeNonStandardRibNote;
          content = content
            ? `${ribLabel}. ${content}`
            : ribLabel;
        }
        if (key === "bottomPole" && this.activeItemHasNonStandardBottomPole) {
          const bpLabel = this.activeNonStandardBottomPoleNote;
          content = content
            ? `${bpLabel} ${content}`
            : bpLabel;
        }
        if (key === "finial" && this.activeItemHasNonStandardFinial) {
          const finialTypeLabel = this.activeNonStandardFinialNote;
          content = content
            ? `${finialTypeLabel}. ${content}`
            : finialTypeLabel;
        }
        if (key === "finial" && this.activeItemHasFinialFinishNote) {
          const finialLabel = this.activeFinialFinishNote;
          content = content
            ? `${finialLabel}. ${content}`
            : finialLabel;
        }
        newItemNotes.push({
          field: key as NoteFields,
          content
        });
      }
      this.updateNotes(newItemNotes, this.activeNoteIndex);
    }
    this.activeNoteObj = null;
    this.activeNoteIndex = null;
  }
}
